import React, { useState, useEffect } from 'react';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Collections from './components/Collections/Collections';
import ExplodedView from './components/ExplodedView/ExplodedView';
import Configurator from './components/Configurator/Configurator';
import Timeline from './components/Timeline/Timeline';
import VideoShowcase from './components/VideoShowcase/VideoShowcase';
import Testimonials from './components/Testimonials/Testimonials';
import Reservation from './components/Reservation/Reservation';
import Footer from './components/Footer/Footer';
import { soundManager } from './utils/soundManager';
import './App.css';

function App() {
  const [loadingComplete, setLoadingComplete] = useState(false);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    if (loadingComplete) {
      // Small delay before showing content for smooth transition
      setTimeout(() => {
        setShowContent(true);
        soundManager.play('whoosh', 0.3);
      }, 500);
    }
  }, [loadingComplete]);

  return (
    <div className="App">
      {!loadingComplete ? (
        <LoadingScreen onComplete={() => setLoadingComplete(true)} />
      ) : (
        <>
          {showContent && (
            <>
              <Navbar />
              <main>
                <Hero />
                <Collections />
                <ExplodedView />
                <Configurator />
                <Timeline />
                <VideoShowcase />
                <Testimonials />
                <Reservation />
              </main>
              <Footer />
            </>
          )}
        </>
      )}
    </div>
  );
}

export default App;